import axios from '@/axios'

const actions = {
  setRoles: ({ commit, state }) => {
    if (state.roles.length) return Promise.resolve() // referência estática: busca 1x
    return axios
      .roles
      .fetch(
        '/roles'
      )
      .then((response) => {
        return commit('roles', response)
      })
  }
}

export default actions
